import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  useLazyGetClassBookingByIdQuery,
  useLazyGetSpecificBookingByIdQuery,
} from "../../services/booking";
import testDateSeries from "../../utils/dateSeries";
import { getOnlyDate, getOnlyTimeHHMM } from "../../utils/formatDateTime";
import moment from "moment";
import Loader from "../../helpers/Loader";
import { CLASS_TYPE, ClassMode } from "../../helpers/constants/enums";

const ClassBookingDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { _id } = useParams();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [ByIdDetails, setByIdDetails] = useState<any>(null);
  const [fetchApi] = useLazyGetClassBookingByIdQuery();
  const { state } = location;

  const fetchDataById = async (_id: any) => {
    setIsLoading(true);
    try {
      const response = await fetchApi({ id: _id }).unwrap();
      setIsLoading(false);
      if (response.statusCode === 200) {
        setByIdDetails(response?.data || null);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
      setByIdDetails(null);
    }
  };

  // useEffect(() => {
  //   if (_id) {
  //     fetchDataById(_id);
  //   }
  // }, [_id]);
  useEffect(() => {
    if (_id) {
      fetchDataById(_id);
    } else {
      console.error("Invalid booking ID");
      navigate("/class-booking"); // fallback navigation
    }
  }, [_id]);

  // if (!ByIdDetails) {
  //   return <Loader isLoad={isLoading} />;
  // }

  return (
    <MainContainer>
      <Loader isLoad={isLoading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1>View Booking Details</h1>
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate(-1);
            }}
          >
            Back
          </Button>
        </div>
        <Card className="cards">
          <CardContent sx={{ p: 1 }}>
            <Grid container spacing={2} className="view_box">
              <Grid item xs={10} className="view_box_list">
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Box>
                      <Typography component="h2" className="subhdng">
                        Customer Details
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Customer Name</Typography>
                      <Typography>
                        {ByIdDetails?.parent?.name || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Email</Typography>
                      <Typography>
                        {ByIdDetails?.parent?.email || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Phone Number</Typography>
                      <Typography>
                        {ByIdDetails?.parent?.dialCode || ""}{" "}
                        {ByIdDetails?.parent?.phoneNo || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box>
                      <Typography component="h2" className="subhdng">
                        Tutor Details
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">
                        Service Provider Name
                      </Typography>
                      <Typography>
                        {ByIdDetails?.tutor?.name || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Email</Typography>
                      <Typography>
                        {ByIdDetails?.tutor?.email || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Phone Number</Typography>
                      <Typography>
                        {ByIdDetails?.tutor?.phoneNo || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box>
                      <Typography component="h2" className="subhdng">
                        Booking Details
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Subject</Typography>
                      <Typography>
                        {ByIdDetails?.subjectId?.name || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Class Topic</Typography>
                      <Typography>
                        {ByIdDetails?.classData?.topic || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Class Description</Typography>
                      <Typography>
                        {ByIdDetails?.classData?.description || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Booking Number</Typography>
                      <Typography>
                        {ByIdDetails?.bookingNumber || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Total Hours</Typography>
                      <Typography>
                        {ByIdDetails?.classSlots?.length || 0} hours
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Class Mode</Typography>
                      <Typography>
                        {ByIdDetails?.classModeOnline === ClassMode.Online
                          ? "Online"
                          : ByIdDetails?.classModeOnline === ClassMode.Offline
                            ? "Offline"
                            : "Hybrid"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Fees</Typography>
                      <Typography>
                        ${ByIdDetails?.classData?.fees || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Grand Total</Typography>
                      <Typography>
                        ${ByIdDetails?.grandTotal || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Service Charges</Typography>
                      <Typography>
                        ${ByIdDetails?.serviceCharges || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Tutor Earnings</Typography>
                      <Typography>
                        ${ByIdDetails?.tutorMoney || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Invoice Number</Typography>
                      <Typography>{ByIdDetails?.invoiceNo || "N/A"}</Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box>
                      <Typography component="h2" className="subhdng">
                        Class Schedule
                      </Typography>
                    </Box>
                  </Grid>

                  {ByIdDetails?.classSlots?.map((slot: any, index: number) => (
                    <Grid item xs={12} key={index}>
                      <Box>
                        <Typography component="h5">
                          Session {index + 1}
                        </Typography>
                        <Typography>
                          Date: {moment(slot.date).format("DD-MM-YYYY")}
                        </Typography>
                        <Typography>
                          Time: {moment(slot.startTime).format("LT")} -{" "}
                          {moment(slot.endTime).format("LT")}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}

                  <Grid item xs={12}>
                    <Box>
                      <Typography component="h2" className="subhdng">
                        Class Location
                      </Typography>
                      <Typography>
                        {ByIdDetails?.classData?.address || "Online Class"}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* <Grid item xs={12}>
                    <Box>
                      <Typography component="h2" className="subhdng">
                        Booking Timeline
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Created At</Typography>
                      <Typography>
                        {moment(ByIdDetails?.createdAt).format(
                          "YYYY-MM-DD, h:mm:ss a"
                        )}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Start Date</Typography>
                      <Typography>
                        {moment(ByIdDetails?.startDate).format(
                          "YYYY-MM-DD, h:mm:ss a"
                        )}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">End Date</Typography>
                      <Typography>
                        {moment(ByIdDetails?.endDate).format(
                          "YYYY-MM-DD, h:mm:ss a"
                        )}
                      </Typography>
                    </Box>
                  </Grid> */}

                  {ByIdDetails?.cancelledAt && (
                    <>
                      <Grid item xs={12}>
                        <Box>
                          <Typography component="h2" className="subhdng">
                            Cancellation Details
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={3}>
                        <Box>
                          <Typography component="h5">
                            Cancellation Date
                          </Typography>
                          <Typography>
                            {moment(ByIdDetails?.cancelledAt).format(
                              "YYYY-MM-DD, h:mm:ss a"
                            )}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={9}>
                        <Box>
                          <Typography component="h5">
                            Reason for cancellation
                          </Typography>
                          <Typography>
                            {ByIdDetails?.cancelReason || "No reason provided"}
                          </Typography>
                        </Box>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    </MainContainer>
  );
};

export default ClassBookingDetails;
